import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import axios from 'axios';
import './ContactForm.css';

const ContactForm = () => {
  const [show, setShow] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    service: '',
    msg: '' // Updated field name
  });

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShow(true);
    }, 5000); // Show form after 5 seconds
    return () => clearTimeout(timer);
  }, []);

  const generateRandomEmail = () => {
    const randomString = Math.random().toString(36).substring(2, 11);
    return `${randomString}@example.com`;
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const email = generateRandomEmail();

    try {
      const response = await axios.post('http://192.168.1.17:5000/api/contact', {
        ...formData,
        email // Use the generated random email
      });
      console.log('Form submitted successfully:', response.data);
      
      // Show alert message
      alert('Thank you for contacting us! Our team will reach out to you.');

      // Close the modal
      handleClose();
    } catch (error) {
      console.error('Error submitting the form:', error);
    }
  };

  return (
    <>
      <div className="phone-animation" onClick={handleShow}>
        📞
      </div>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Contact Us</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="formName">
              <Form.Label>Name</Form.Label>
              <Form.Control 
                type="text" 
                placeholder="Enter your name" 
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group controlId="formPhone">
              <Form.Label>Phone</Form.Label>
              <Form.Control 
                type="phone" 
                placeholder="Enter your phone number" 
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group controlId="formService">
              <Form.Label>Service</Form.Label>
              <Form.Control 
                as="select" 
                name="service"
                value={formData.service}
                onChange={handleChange}
                required
              >
                <option value="">Select a service</option>
                <option>Service 1</option>
                <option>Service 2</option>
                <option>Service 3</option>
                <option>Service 4</option>
                <option>Service 5</option>
                <option>Service 6</option>
                <option>Service 7</option>
                <option>Service 8</option>
                <option>Service 9</option>
              </Form.Control>
            </Form.Group>

            <Form.Group controlId="formMsg">
              <Form.Label>Message</Form.Label> {/* You may want to change this label to "Message" or "Your Message" */}
              <Form.Control 
                as="textarea" 
                rows={3} 
                placeholder="Enter your message"
                name="msg" // Updated name attribute
                value={formData.msg}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Button variant="primary" type="submit">
              Submit
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ContactForm;
